import { render, staticRenderFns } from "./DatetimeSpan.vue?vue&type=template&id=5a4bbeb9&"
import script from "./DatetimeSpan.vue?vue&type=script&lang=ts&"
export * from "./DatetimeSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports